// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__2axhl","inputDescription":"styles_inputDescription__2z2Wn"};